export async function getParametersRequest() {
  let res = await fetch("/api/getParameters");

  return await res.json();
}
export async function getEvaluationParametersRequest(sessionID: string) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    session_id: sessionID
  });

  let res = await fetch("/api/evaluation_getParameters", {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  });

  return await res.json();
}

export async function trainRequest(optionSelected: any) {
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  let raw = JSON.stringify(optionSelected);

  let res = await fetch("/api/train", {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  });

  return await res.json();
}

export async function PMRequest(optionSelected: any) {
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  let raw = JSON.stringify(optionSelected);

  let res = await fetch("/api/portfolio_management", {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  });

  return await res.json();
}


export async function trainStatusRequest(sessionID: string) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    session_id: sessionID
  });

  let res = await fetch("/api/train_status", {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  });

  return await res.json();
}

export async function testRequest(sessionID: string) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    session_id: sessionID
  });

  let res = await fetch("/api/test", {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  });

  return await res.json();
}

export async function styleTestRequest(sessionID: string, style_test: string) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    session_id: sessionID,
    style_test: style_test
  });

  let res = await fetch("/api/style_test", {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  });

  return await res.json();
}

export async function testStatusRequest(sessionID: string) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    session_id: sessionID
  });

  let res = await fetch("/api/test_status", {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  });

  return await res.json();
}

export async function showMarketDynamicsLabelingRequest(
  sessionID: any,
  optionSelected: any
) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    ...optionSelected,
    session_id: sessionID
  });

  let res = await fetch("/api/start_market_dynamics_labeling", {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  });

  return await res.json();
}

export async function saveMarketDynamicsLabelingRequest(sessionID: string) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    session_id: sessionID
  });
  let res = await fetch("/api/save_market_dynamics_labeling", {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  });

  return await res.json();
}

export async function runDynamicsTest(
  sessionID: string,
  dynamics_test_label: any
) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    dynamics_test_label: dynamics_test_label,
    session_id: sessionID
  });
  let res = await fetch("/api/run_dynamics_test", {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  });

  return await res.json();
}

export async function runDynamicsLabelTestStatus(
  sessionID: string,
  dynamic_label_number: string
) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    session_id: sessionID,
    dynamics_test_label: dynamic_label_number
  });

  let res = await fetch("/api/dynamics_testing_status", {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  });

  return await res.json();
}

export async function dynamicsTestStatusRequest(sessionID: string) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    session_id: sessionID
  });
  let res = await fetch("/api/MDM_status", {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  });

  return await res.json();
}

export async function uploadCSV(
  session_id: any,
  fileData: any,
  fileMetaData: any
) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  console.log("inside Req-fileData", fileData);
  let fileDataStr = JSON.stringify(fileData);
  console.log("inside Req-fileDataStr", fileDataStr);
  var raw = JSON.stringify({
    file: fileDataStr,
    file_name: fileMetaData.name,
    session_id: session_id
  });
  console.log(raw);

  let res = await fetch("/api/upload_csv", {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  });

  return await res.json();
}

export async function downloadCSV(session_id: String) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    session_id: session_id
  });

  let res = await fetch("/api/download_csv", {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  });

  return await res.json();
}

export async function portfolioManagement(optionSelected: any) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(optionSelected);

  let res = await fetch("/api/portfolio_management", {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  });

  return await res.json();
}
